import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { AgreementRepository } from "../../repositories/agreement.repository";

interface PublishOpportunityUseCaseParam {
  agreementId: number;
  //   smarts: SaveAgreementDTO[];
}
export class PublishOpportunityUseCase
  implements UseCase<PublishOpportunityUseCaseParam, boolean>
{
  constructor(private repo: AgreementRepository) {}
  execute(param: PublishOpportunityUseCaseParam): Observable<boolean> {
    return this.repo.publishOpportunity(
      param.agreementId,
      //  param.smarts
    );
  }
}

const publishOpportunityUseCaseFactory = (repo: AgreementRepository) =>
  new PublishOpportunityUseCase(repo);

export const publishOpportunityUseCaseProvider: Provider = {
  provide: PublishOpportunityUseCase,
  useFactory: publishOpportunityUseCaseFactory,
  deps: [AgreementRepository],
};
